var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"height":"100%"}},[_c('project-flow-navigation-toolbar',{attrs:{"title":_vm.projectName}}),_c('v-card-text',{staticStyle:{"height":"calc(100% - 116px)"}},[_c('new-manage-media')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }